// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__vYRLl","alert":"SettungsInbox_alert__2gJxt"};